export const constants = {
  MFE_EFFICIENCY_NAME: 'efficiency',
  MFE_EXPOSED_PATH: './EfficiencyApp',
  MFE_MOBILE_EXPOSED_PATH: './EfficiencyMobile',
  TREND_GRAPH_EXPOSED_PATH: './TrendGraph',
};
